module.exports = __webpack_public_path__ + "static/mormontrek-fe33ed6bad429b495ede1e665973794f.jpg";